import { Component, model } from '@angular/core';
import { CoreModule, IvvTitleComponent, OffersType } from '@toevla-webapplications/core';
import { TranslateModule } from '@ngx-translate/core';
import { ImageCarouselComponent } from '../detail/components/image-carousel/image-carousel.component';
import { OfferImage } from '../../services/offers/offer-image.model';

@Component({
    selector: 'ivva-kampas',
    templateUrl: './kampas.component.html',
    styleUrls: ['./kampas.component.scss'],
    imports: [CoreModule, IvvTitleComponent, TranslateModule, ImageCarouselComponent]
})
export class KampasComponent {
	indexImageCarousel = model<number | null>(null);

	readonly IMAGES: Partial<OfferImage>[] = [
		{ url: '/assets/img/kampas/logo.png' },
		{ url: '/assets/img/kampas/001.jpg' },
		{ url: '/assets/img/kampas/002.jpg' },
		{ url: '/assets/img/kampas/003.jpg' },
		{ url: '/assets/img/kampas/004.jpg' },
		{ url: '/assets/img/kampas/005.jpg' },
		{ url: '/assets/img/kampas/006.jpg' },
		{ url: '/assets/img/kampas/hostel-wadi.jpg' },
		{ url: '/assets/img/kampas/snuffel-vzw.jpg' },
		{ url: '/assets/img/kampas/bielebale-2-dezon.jpg' },
	];

	protected readonly OffersType = OffersType;
}
